import { Loadable } from 'foundations-components/transitional/utils/Loadable';
export default Loadable({
  loader: () => import( /* webpackChunkName: "assign-permissions-panel" */'./AssignPermissionsPanel').then(mod => mod.default),
  LoadingComponent: () => null
});